var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { formatDate as format, avatarHtml } from '@/support/String';
import { Notification } from '@/models/Notification';
import AbstractNotification from '@/components/notifications-card/AbstractNotification';
import { RolesEnum } from '@/items/Roles';
let NotificationHistory = class NotificationHistory extends AbstractNotification {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Audits';
        this.activeTab = 'new-chats';
        this.visible = {
            search: false,
            total: true,
            limit: true,
            pagination: true,
            checkboxes: false,
        };
    }
    get defaultTableOptions() {
        return {
            headers: [
                {
                    text: '',
                    value: 'meta',
                    transform: (meta, notification) => {
                        return this.parseAvatar(this.transformNotification(notification, true).avatar);
                    },
                    width: '10%',
                },
                {
                    text: 'Message',
                    value: 'meta',
                    transform: (meta, notification) => {
                        const parsedNotification = this.transformNotification(notification, true);
                        return `${parsedNotification.title} <br> ${parsedNotification.subtitle}`;
                    },
                    action: (notification) => {
                        const action = this.transformNotification(notification, true).action;
                        return action ? this.$router.push(action) : null;
                    },
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'open_in_new',
                    action: (DataTable, notification) => {
                        const action = this.transformNotification(notification, true).action;
                        const routeData = this.$router.resolve(action);
                        window.open(routeData.href, '_blank');
                        notification
                            .update()
                            .then((response) => {
                            this.refreshDataTable();
                        });
                    },
                },
            ],
            filters: [],
        };
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    get tableOptionsChats() {
        return { ...this.defaultTableOptions, ...{
                name: {
                    singular: `${this.$tc('chat.title', 2)}`,
                    plural: `${this.$tc('chat.title', 2)}`,
                },
                model: new Notification().include('subject').filter({ types: ['student.messages.teacher', 'student.messages.guardian', 'student.messages.student-guardian'] }),
            } };
    }
    get tableOptionsNewChats() {
        return { ...this.defaultTableOptions, ...{
                name: {
                    singular: `${this.$tc('chat.title', 2)}`,
                    plural: `${this.$tc('chat.title', 2)}`,
                },
                model: new Notification().limit(250).include('subject').filter({ read: false }),
                actions: [
                    {
                        type: 'view',
                        label: 'view',
                        icon: 'open_in_new',
                        action: (DataTable, notification) => {
                            const action = this.transformNotification(notification, true).action;
                            const routeData = this.$router.resolve(action);
                            window.open(routeData.href, '_blank');
                            notification
                                .update()
                                .then((response) => {
                                this.refreshDataTable();
                            });
                        },
                    },
                    {
                        type: 'mark_as_read',
                        label: 'Markeren als gelezen',
                        icon: 'check',
                        action: (DataTable, notification) => {
                            notification
                                .update()
                                .then((response) => {
                                this.refreshDataTable();
                            });
                        },
                    },
                ],
            } };
    }
    get tableOptionsPlp() {
        return { ...this.defaultTableOptions, ...{
                name: {
                    singular: `PLP ${this.$tc('chat.title', 2)}`,
                    plural: `PLP ${this.$tc('chat.title', 2)}`,
                },
                model: new Notification().include('subject').filter({ type: 'student.idp.subject' }),
            } };
    }
    get tableOptionsGroup() {
        return { ...this.defaultTableOptions, ...{
                name: {
                    singular: `${this.$tc('chat.group.title', 1)} ${this.$tc('chat.title', 2)}`,
                    plural: `${this.$tc('chat.group.title', 1)} ${this.$tc('chat.title', 2)}`,
                },
                model: new Notification().include('subject').filter({ type: 'group.messages' }),
            } };
    }
    get tableOptionsSubject() {
        return { ...this.defaultTableOptions, ...{
                name: {
                    singular: `${this.$tc('chat.subject', 2)}`,
                    plural: `${this.$tc('chat.subject', 2)}`,
                },
                model: new Notification().include('subject').filter({ type: 'subject.messages' }),
            } };
    }
    get tabs() {
        return [
            {
                name: `${this.$tc('notifications.tabs.new_chat', 1)}`,
                href: '#new-chats',
                role: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.STUDENT],
            },
            {
                name: `${this.$tc('notifications.tabs.chat', 1)}`,
                href: '#chats',
                role: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TEACHER],
            },
            {
                name: `PLP ${this.$tc('notifications.tabs.plp', 1)}`,
                href: '#plp',
                role: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TEACHER],
            },
            {
                name: `${this.$tc('notifications.tabs.group', 1)}`,
                href: '#group',
                role: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.STUDENT],
            },
            {
                name: `${this.$tc('notifications.tabs.subject', 1)}`,
                href: '#subject',
                role: [RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.STUDENT],
            },
        ];
    }
    parseAvatar(avatar) {
        return avatar ? avatarHtml(avatar) : avatarHtml(require('@/assets/images/icons/default-avatar.svg'));
    }
};
NotificationHistory = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            SelectFilter,
        },
        filters: {
            formatTime(time) {
                if (!time) {
                    return '';
                }
                if (time === '00:00:00') {
                    return '-';
                }
                const parts = time.split(':');
                return `${parts[0]}:${parts[1]}`;
            },
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
            formatKey(key) {
                return key.replace(':', ' ');
            },
        },
    })
], NotificationHistory);
export default NotificationHistory;
